import React from "react";
import  ReactDOM  from "react-dom";

// Our main Component
import App from './App'

ReactDOM.render(
    <App/>, document.getElementById("root")
)